import React from "react";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { InputAdornment } from "@mui/material";
import calendarIcon from "../../assets/images/calendar_icon.png";

const DatePickerWithIcon = ({ label, value, onChange }) => {
  return (
    <div className="trip-request-filter-item">
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <label>{label}</label>
        <MobileDatePicker
          className="trip-request-datePicker"
          value={value}
          format="DD MMM,YYYY"
          onChange={onChange}
          slotProps={{
            textField: {
              placeholder: "--/--/----",
              InputProps: {
                startAdornment: (
                  <InputAdornment position="start">
                    <img
                      src={calendarIcon}
                      alt="calendar icon"
                      className="trip-request-calendar-icon"
                    />
                  </InputAdornment>
                ),
              },
            },
          }}
        />
      </LocalizationProvider>
    </div>
  );
};

export default DatePickerWithIcon;
